import React, { useState, useEffect } from 'react';
import '../../../styles/vendeurs/VendeurFooter.css';

function FooterSection({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="footer-column">
      <h4 onClick={() => isMobile && setIsOpen(!isOpen)}>{title}</h4>
      <ul className={`footer-list ${isMobile && !isOpen ? 'collapsed' : ''}`}>
        {children}
      </ul>
    </div>
  );
}

export default function VendeurFooter() {
  return (
    <footer className="footer">
      <div className="footer-columns">
        <FooterSection title="ESPACE VENDEUR">
          <li><a href="/vendeur/cgv">CGV Vendeur</a></li>
          <li><a href="/vendeur/confidentialite">Politique de confidentialité</a></li>
        </FooterSection>

        <FooterSection title="MON ESPACE">
          <li><a href="/vendeur/produits">Mes produits</a></li>
          <li><a href="/vendeur/commandes">Mes commandes</a></li>
          <li><a href="/vendeur/profile">Mon profil</a></li>
        </FooterSection>

        <FooterSection title="ASSISTANCE">
          <li>034 69 402 91</li>
          <li>034 67 101 37</li>
          <li><a href="mailto:support@tsenannytantsaha.mg">support@tsenannytantsaha.mg</a></li>
        </FooterSection>

        <FooterSection title="RÉSEAUX SOCIAUX">
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">FB</a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">IG</a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">IN</a>
          </div>
        </FooterSection>
      </div>
    </footer>
  );
}
